/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CardMedia, Grid, IconButton, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { MFTextField } from '../../lib/formik';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import MFCheckbox from '../../lib/formik/Checkbox';
import { ApplicationProps, NomineeType } from '../../redux-store/types/api-types';
import {
  applicationComparison,
  applyRoleBasedStatus,
  getApplicantName,
  getNomineeRelation,
  getStep,
  ifPushToXalt,
  isMinor,
  isOnboardingTypeMinor,
  nomineeRelationForAgeMajor,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { DatePicker } from '../../lib/formik/DatePicker';
import { ConfirmationDialog } from '../commonComponents';
import { nomineeDetailsSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  ExcludedNomineeGuardianRelations,
  NomineeRelations,
  SAVE_LATER_VALIDATION_CHECK,
} from '../../utils/constant';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import FieldValidationNote from './FieldValidationNote';

type updateNominee = NomineeType & {
  Relationship: string | null;
  guardianRelationOther?: string | null;
};

type Values = {
  doNotWishToNominate: boolean;
  nominees: updateNominee[];
  saveType: string;
};

const getDateOfAttainingMajority = (dateOfBirth?: string | null) => {
  if (!dateOfBirth) return null;
  const dob = new Date(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return null;
  dob.setFullYear(dob.getFullYear() + 18);
  return dob.toISOString();
};

const newNominee: updateNominee = {
  nomineeName: '',
  nomineeRelationship: '',
  dateOfBirth: null,
  nomineePercentage: 0,
  guardianName: '',
  isActive: true,
  Relationship: '',
  taxIdNumber: '',
  dateOfAttainingMajority: null,
  guardianAddress: '',
  guardianTaxIdNumber: '',
  guardianRelationship: '',
  guardianRelationOther: '',
  guardianMobile: '',
  guardianDateOfBirth: null,
  guardianEmail: '',
  nomineeAddress: '',
  nomineeEmail: '',
  nomineeMobile: '',
};

const initialValues: Values = {
  doNotWishToNominate: true,
  nominees: [newNominee],
  saveType: 'save and proceed',
};

const Nominee = ({
  nomineeName,
  index,
  values,
  createdAt,
  ifXalt,
}: {
  nomineeName: number;
  index: number;
  values: Values;
  createdAt: string;
  ifXalt: boolean;
}): JSX.Element => {
  const { dateOfBirth = '', Relationship = '' } = values.nominees[index];
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineeName`}
          label={`Nominee Name - ${nomineeName} *`}
          placeholder={`Enter Nominee Name - ${nomineeName}`}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineeEmail`}
          label="Nominee Email *"
          placeholder="Enter Nominee Email"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineeMobile`}
          label="Nominee Mobile Number *"
          placeholder="Enter Nominee Mobile Number"
        />
      </Grid>
      <Grid item xs={12}>
        <MFTextField
          name={`nominees.${index}.nomineeAddress`}
          label="Nominee Address *"
          placeholder="Enter Nominee Address"
          multiline
          rows={3}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`nominees.${index}.Relationship`}
          label="Nominee Relationship with the First Holder *"
          items={NomineeRelations.filter((relation) => {
            const { nominees } = values;
            const selectedRelations = nominees
              .filter(
                (nominee, ind) =>
                  ind !== index &&
                  nominee.Relationship &&
                  ['MOTHER', 'FATHER', 'SPOUSE'].includes(nominee.Relationship)
              )
              .map((nominee) => nominee.Relationship);
            return !selectedRelations.includes(relation);
          }).map((relation) => ({
            key: relation,
            value: relation,
          }))}
        />
      </Grid>
      {values.nominees[index].Relationship === 'OTHERS' && (
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`nominees.${index}.nomineeRelationship`}
            label="Please Specify Relationship *"
            placeholder={`Enter Nominee Relationship`}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.nomineePercentage`}
          label="Nominee % *"
          placeholder="Enter Nominee %"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`nominees.${index}.taxIdNumber`}
          label="Nominee Identification Number *"
          placeholder="Enter Nominee Identification Number"
          infoText="PAN/Aadhar/DL for Resident & Passport for NRI"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DatePicker
          label={`Nominee Date of Birth *`}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Nominee Date of Birth'}
          name={`nominees.${index}.dateOfBirth`}
        />
      </Grid>
      {!nomineeRelationForAgeMajor(Relationship || '') && isMinor(dateOfBirth ? dateOfBirth : '') && (
        <>
          {/* <Grid item xs={12} sm={6}>
            <DatePicker
              label={'Date of Attaining Majority *'}
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              placeholder={'Enter Date of Attaining Majority'}
              name={`nominees.${index}.dateOfAttainingMajority`}
              maxDate={
                new Date(
                  `${new Date(dateOfBirth || '').getFullYear() + 18}-${
                    new Date(dateOfBirth || '').getMonth() + 1
                  }-${new Date(dateOfBirth || '').getDate()}`
                )
              }
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.guardianName`}
              label="Guardian Name *"
              placeholder="Enter Guardian Name"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.guardianTaxIdNumber`}
              label="Guardian Identification Number *"
              placeholder="Enter Guardian Identification Number"
              infoText="PAN/Aadhar/DL for Resident & Passport for NRI"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFSelectField
              name={`nominees.${index}.guardianRelationship`}
              label="Guardian Relationship with nominee *"
              items={NomineeRelations.filter(
                (relation) => !ExcludedNomineeGuardianRelations.includes(relation)
              ).map((relation) => ({
                key: relation,
                value: relation,
              }))}
            />
          </Grid>
          {values.nominees[index].guardianRelationship === 'OTHERS' && (
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`nominees.${index}.guardianRelationOther`}
                label="Please Specify Relationship *"
                placeholder="Enter Guardian Relationship with nominee"
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <DatePicker
              label={'Guardian Date of Birth *'}
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              placeholder={'Enter Guardian Date of Birth'}
              name={`nominees.${index}.guardianDateOfBirth`}
              maxDate={
                new Date(
                  `${new Date(dateOfBirth || '').getFullYear() + 18}-${
                    new Date(dateOfBirth || '').getMonth() + 1
                  }-${new Date(dateOfBirth || '').getDate()}`
                )
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.guardianMobile`}
              label="Guardian Mobile Number *"
              placeholder="Enter Guardian Mobile Number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.guardianEmail`}
              label="Guardian Email *"
              placeholder="Enter Guardian Email"
            />
          </Grid>
          <Grid item xs={12}>
            <MFTextField
              name={`nominees.${index}.guardianAddress`}
              label="Guardian Address *"
              placeholder="Enter Guardian Address"
              multiline
              rows={3}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default function NomineeDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [nomineesData, setNomineesData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [nomineeToDelete, setNomineeToDelete] = useState<{
    nominee: Partial<NomineeType>;
    index: number;
  } | null>(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { flowType = '' } = application || {};
  const ifXalt = ifPushToXalt(application?.pushDataTo || '');

  const onSubmit = async (values: Values) => {
    try {
      const {
        nominees: existingNominees = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
        createdAt,
      } = application || {};
      const { nominees, doNotWishToNominate, saveType } = values;
      const updatedPayload = {
        ...application,
        doNotWishToNominate,
        nominees: doNotWishToNominate
          ? []
          : nominees.map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, guardianRelationOther, ...rest } = nominee;
                return {
                  ...(existingNominees[index] || {}),
                  ...rest,
                  nomineeRelationship:
                    Relationship === 'OTHERS'
                      ? removeSingleQuote(rest.nomineeRelationship)
                      : removeSingleQuote(Relationship), // Relationship is already .toUpperCase() from useEffect
                  dateOfBirth: !nominee.dateOfBirth
                    ? null
                    : new Date(nominee.dateOfBirth).toISOString(),
                  dateOfAttainingMajority: isMinor(rest.dateOfBirth || '')
                    ? getDateOfAttainingMajority(rest.dateOfBirth)
                    : null,
                  isActive: nominee.isActive && !doNotWishToNominate,
                  nomineeName: removeSingleQuote(rest.nomineeName),
                  nomineeAddress: removeSingleQuote(rest.nomineeAddress || ''),
                  nomineeEmail: removeSingleQuote(rest.nomineeEmail || ''),
                  nomineeMobile: removeSingleQuote(rest.nomineeMobile || ''),
                  guardianName: isMinor(rest.dateOfBirth || '')
                    ? removeSingleQuote(rest.guardianName)
                    : null,
                  guardianAddress: isMinor(rest.dateOfBirth || '')
                    ? removeSingleQuote(rest.guardianAddress)
                    : null,
                  guardianTaxIdNumber: isMinor(rest.dateOfBirth || '')
                    ? rest?.guardianTaxIdNumber
                    : null,
                  guardianRelationship: isMinor(rest.dateOfBirth || '')
                    ? removeSingleQuote(
                        rest.guardianRelationship === 'OTHERS'
                          ? guardianRelationOther || ''
                          : rest.guardianRelationship
                      )
                    : null,
                  guardianMobile: isMinor(rest.dateOfBirth || '')
                    ? removeSingleQuote(rest.guardianMobile || '')
                    : null,
                  guardianEmail: isMinor(rest.dateOfBirth || '')
                    ? removeSingleQuote(rest.guardianEmail || '')
                    : null,
                  guardianDateOfBirth: isMinor(rest.dateOfBirth || '')
                    ? !rest.guardianDateOfBirth
                      ? null
                      : new Date(rest.guardianDateOfBirth).toISOString()
                    : null,
                };
              }
              const { Relationship, guardianRelationOther, ...rest1 } = nominees[index];
              return {
                ...rest1,
                nomineeRelationship:
                  Relationship === 'OTHERS'
                    ? removeSingleQuote(rest1.nomineeRelationship)
                    : Relationship,
                nomineeName: removeSingleQuote(rest1.nomineeName),
                nomineeAddress: removeSingleQuote(rest1.nomineeAddress || ''),
                nomineeEmail: removeSingleQuote(rest1.nomineeEmail || ''),
                nomineeMobile: removeSingleQuote(rest1.nomineeMobile || ''),
                guardianName: isMinor(rest1.dateOfBirth || '')
                  ? removeSingleQuote(rest1.guardianName)
                  : null,
                guardianAddress: isMinor(rest1.dateOfBirth || '')
                  ? removeSingleQuote(rest1.guardianAddress)
                  : null,
                guardianTaxIdNumber: isMinor(rest1.dateOfBirth || '')
                  ? rest1?.guardianTaxIdNumber
                  : null,
                dateOfAttainingMajority: isMinor(rest1.dateOfBirth || '')
                  ? getDateOfAttainingMajority(rest1.dateOfBirth)
                  : null,
                guardianRelationship: isMinor(rest1.dateOfBirth || '')
                  ? removeSingleQuote(
                      rest1.guardianRelationship === 'OTHERS'
                        ? guardianRelationOther || ''
                        : rest1.guardianRelationship
                    )
                  : null,
                guardianMobile: isMinor(rest1.dateOfBirth || '')
                  ? removeSingleQuote(rest1.guardianMobile || '')
                  : null,
                guardianEmail: isMinor(rest1.dateOfBirth || '')
                  ? removeSingleQuote(rest1.guardianEmail || '')
                  : null,
                guardianDateOfBirth: isMinor(rest1.dateOfBirth || '')
                  ? !rest1.guardianDateOfBirth
                    ? null
                    : new Date(rest1.guardianDateOfBirth).toISOString()
                  : null,
              };
            }),
      };
      const checkApplication = applicationComparison(
        {
          ...application,
          nominees: application?.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
        },
        {
          ...updatedPayload,
          nominees: updatedPayload.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
          currentStep: !!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: getStep(6, isSaveLater),
              ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
              //!!currentStep && currentStep > 5 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
            flowType,
          })
        );
        !isSaveLater
          ? history.push('bank-details', { id, applicant1ReferenceId })
          : history.push(
              saveForLater(role, id, applicant1ReferenceId, application as ApplicationProps)
            );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('bank-details', { id, applicant1ReferenceId })
          : history.push(
              saveForLater(role, id, applicant1ReferenceId, application as ApplicationProps)
            );
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  useEffect(() => {
    const { nominees = [], doNotWishToNominate = true, onboardingType = '' } = application || {};
    setNomineesData({
      ...nomineesData,
      doNotWishToNominate: isOnboardingTypeMinor(onboardingType)
        ? true
        : nominees.length
        ? false
        : doNotWishToNominate === null
        ? true
        : doNotWishToNominate,
      nominees: nominees.length
        ? nominees.map((nominee) => {
            return {
              ...nominee,
              Relationship: nominee.nomineeRelationship
                ? getNomineeRelation(nominee.nomineeRelationship.toUpperCase())
                  ? nominee.nomineeRelationship.toUpperCase()
                  : 'OTHERS'
                : '',
              nomineeRelationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
                ? ''
                : nominee.nomineeRelationship,
              guardianRelationship: getNomineeRelation(nominee.guardianRelationship?.toUpperCase())
                ? nominee.guardianRelationship?.toUpperCase() ?? ''
                : 'OTHERS',
              guardianRelationOther: getNomineeRelation(nominee.guardianRelationship?.toUpperCase())
                ? ''
                : nominee.guardianRelationship,
              isActive: isOnboardingTypeMinor(onboardingType)
                ? !nominee.isActive
                : nominee.isActive,
            };
          })
        : [],
    });
  }, [application]);

  return (
    <Formik
      initialValues={nomineesData}
      onSubmit={onSubmit}
      enableReinitialize={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            nomineeDetailsSchema(
              ifPushToXalt(application?.pushDataTo || ''),
              application?.createdAt || ''
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Notes displayContent={'Contributor(s) have the option to choose upto three nominees'} />
          {values.nominees.map((nominee, index) => (
            <React.Fragment key={index}>
              <SubHeading
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}>
                {getApplicantName(index + 1, true)} Nominee Details
                <Box
                  sx={{ display: 'flex', alignItems: 'center' }}
                  onClick={() => setNomineeToDelete({ nominee, index })}>
                  <Typography
                    sx={{
                      color: 'rgba(196, 42, 51, 0.8)',
                      fontSize: 12,
                      ml: 'auto',
                      letterSpacing: '-0.2px',
                      cursor: 'pointer',
                    }}>
                    Remove Nominee{' '}
                  </Typography>
                  <IconButton sx={{ p: '2px' }}>
                    <CardMedia
                      component="img"
                      src="/images/delete-red.svg"
                      alt="Delete Icon"
                      sx={{ width: 'unset' }}
                    />
                  </IconButton>
                </Box>
              </SubHeading>
              <Nominee
                nomineeName={index + 1}
                index={index}
                key={index}
                values={values}
                createdAt={application?.createdAt || ''}
                ifXalt={ifXalt}
              />
            </React.Fragment>
          ))}
          <Grid item xs={12}>
            <MFCheckbox
              disabled={
                !!values.nominees.length || isOnboardingTypeMinor(application?.onboardingType || '')
              }
              name="doNotWishToNominate"
              label="I do not wish to nominate."
              sx={{ letterSpacing: '1px' }}
              onChange={({ target: { checked } }) => {
                const updatedNominees = !checked
                  ? [...values.nominees, newNominee]
                  : values.nominees;
                setValues({
                  ...nomineesData,
                  doNotWishToNominate: checked,
                  nominees: updatedNominees.map((nominee) => ({
                    ...nominee,
                    nomineePercentage: 100,
                    isActive: !checked,
                  })),
                });
              }}
              checked={values.doNotWishToNominate}
            />
            <Typography variant="body2" sx={{ pl: 4, fontSize: 16, textAlign: 'justify' }}>
              I/ We hereby confirm that I /We do not wish to appoint any nominee(s) for my units of
              retail fund held in my / our folio /d mat account and understand the issues involved
              in non-appointment of nominee(s) and further are aware that in case of death of all
              the account holder(s), my / our legal heirs would need to submit all the requisite
              documents for claiming of assets held in my / our folio/ demat account which may also
              include documents issued folio/demat by Court or other such competent authorty, based
              on the value of assets held in the folio.{' '}
            </Typography>
          </Grid>

          {values.nominees.length < 3 && (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                disabled={isOnboardingTypeMinor(application?.onboardingType || '')}
                sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  mt: 2,
                }}
                onClick={() =>
                  setValues({
                    ...values,
                    nominees: [
                      ...values.nominees,
                      { ...newNominee, nomineePercentage: values.nominees.length ? 0 : 100 },
                    ],
                    doNotWishToNominate: false,
                  })
                }>
                Add Nominee
              </Button>
            </Grid>
          )}
          <FieldValidationNote />
          <ProceedSaveLater
            goToPreviousStep={() => {
              history.push('fatca');
            }}
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
          <ConfirmationDialog
            message={'Are you sure you want to delete nominee ?'}
            open={nomineeToDelete !== null}
            setOpen={() => setNomineeToDelete(null)}
            onSave={async () => {
              try {
                const { id } = application || {};
                const remainedApplicants = values.nominees.map((nominee, i) => {
                  if (i === nomineeToDelete?.index) {
                    return {
                      ...nominee,
                      isActive: false,
                    };
                  }
                  return nominee;
                });
                const sortedNominees = remainedApplicants.filter((applicant) => applicant.isActive);
                setNomineeToDelete(null);
                if (id && nomineeToDelete?.nominee.id) {
                  await dispatch(
                    updateApplication({
                      body: {
                        ...application,
                        nominees: remainedApplicants.map((nominee: updateNominee) => {
                          const { Relationship, guardianRelationOther, ...rest } = nominee;
                          return {
                            ...rest,
                            nomineeRelationship:
                              Relationship === 'OTHERS'
                                ? nominee.nomineeRelationship
                                : Relationship,
                          };
                        }),
                        doNotWishToNominate:
                          sortedNominees.length === 0 ? true : values.doNotWishToNominate,
                        status:
                          !application?.hasPOA &&
                          AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                          application?.status !== 'draft' &&
                          applyRoleBasedStatus(role)
                            ? 'sent_to_amc_approver'
                            : application?.status,
                      },
                      applicationId: id,
                      flowType,
                    })
                  );
                  return;
                }
                setValues({
                  ...values,
                  nominees: sortedNominees,
                  doNotWishToNominate:
                    sortedNominees.length === 0 ? true : values.doNotWishToNominate,
                });
              } catch (e) {
                console.error((e as Error).message);
              }
            }}
            onCancel={() => setNomineeToDelete(null)}
          />
        </Grid>
      )}
    </Formik>
  );
}
